export const DEFAULT_STATE = {
    isLoading: false,
    countries: null,
    publisherCountry: null,
    bankCountry: null,
};
